import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [attempts, setAttempts] = useState(0);
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) return;
    let stop = false;
    const poll = async () => {
      if (stop) return;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setStatus(r.data.payment_status);
        if (r.data.payment_status === "paid") { await refresh(); return; }
      } catch { /* noop */ }
      if (attempts > 20) return;
      setAttempts((a) => a + 1);
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="min-h-[calc(100vh-72px)] flex items-center justify-center px-4 py-16 bg-[#FDFBF7]">
      <Card className="p-10 max-w-md w-full text-center border-[#EAE3D2] bg-white" data-testid="payment-success-card">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 mx-auto text-emerald-600" />
            <h1 className="font-serif text-3xl text-slate-900 mt-4">Payment successful</h1>
            <p className="text-slate-600 mt-2">Your plan is now active for 6 months. Enjoy your journey with EliteNRIMatrimony.</p>
            <Link to="/dashboard"><Button className="mt-6 bg-[#6B1D2F] hover:bg-[#541624] text-white rounded-full px-8">Go to Dashboard</Button></Link>
          </>
        ) : (
          <>
            <Loader2 className="w-16 h-16 mx-auto text-[#6B1D2F] animate-spin" />
            <h1 className="font-serif text-2xl text-slate-900 mt-4">Confirming your payment…</h1>
            <p className="text-slate-600 mt-2">One moment while we finalise your plan.</p>
          </>
        )}
      </Card>
    </div>
  );
}
